import React from "react";

// BazookaHistoryPanel — recent fires table for ChairmansBazooka.
// Shows when, who, which channel, delivery status, and claim/redeem
// state (with nudge counter for un-claimed pending invites). Extracted
// from ChairmansBazooka (Iter-58.6 split) so the table stays isolated
// from the firing form.
const BazookaHistoryPanel = ({ history }) => (
  <div
    data-testid="bazooka-history"
    className="rounded-lg border border-gray-800 bg-gray-900/40 p-3 max-h-96 overflow-y-auto"
  >
    {history.length === 0 ? (
      <p className="text-gray-500 text-xs italic">No fires yet.</p>
    ) : (
      <table className="w-full text-xs">
        <thead>
          <tr className="text-gray-500 text-left">
            <th className="px-2 py-1">When</th>
            <th className="px-2 py-1">Target</th>
            <th className="px-2 py-1">Channel</th>
            <th className="px-2 py-1">Delivered</th>
            <th className="px-2 py-1">Claimed</th>
          </tr>
        </thead>
        <tbody>
          {history.map((h) => (
            <tr
              key={h.token_preview || `${h.sent_at}_${h.email || h.phone || ""}`}
              className="border-t border-gray-800/70 text-gray-300"
            >
              <td className="px-2 py-1 whitespace-nowrap">
                {h.sent_at ? new Date(h.sent_at).toLocaleString() : "—"}
              </td>
              <td className="px-2 py-1">
                <span className="text-white">
                  {h.first_name} {h.last_name}
                </span>
                {h.username && (
                  <span className="ml-1 text-amber-300 text-[10px]">
                    @{h.username}
                  </span>
                )}
                <br />
                <span className="text-gray-500">{h.email || h.phone}</span>
              </td>
              <td className="px-2 py-1">{h.channel}</td>
              <td className="px-2 py-1">
                {h.delivered ? (
                  <span className="text-emerald-400">✓</span>
                ) : (
                  <span className="text-rose-400">✗</span>
                )}
              </td>
              <td className="px-2 py-1">
                {h.redeemed_at ? (
                  <span className="text-emerald-400">
                    {new Date(h.redeemed_at).toLocaleDateString()}
                  </span>
                ) : h.invalidated_at ? (
                  <span className="text-gray-500">replaced</span>
                ) : (
                  <span className="inline-flex flex-col gap-0.5">
                    <span className="text-gray-500">pending</span>
                    {(h.nudge1_sent_at || h.nudge2_sent_at) && (
                      <span className="text-amber-300 text-[10px]">
                        {h.nudge2_sent_at ? "nudged ×2" : "nudged ×1"}
                      </span>
                    )}
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
);

export default BazookaHistoryPanel;
